import { APP_CONSTANTS } from 'src/consumer/constants'
import logo_brand from 'src/assets/logo_brand.png'
import about_icon from 'src/assets/about_icon.png'

import ArrowLeftIcon from '@mui/icons-material/ArrowLeft'
import { Avatar, Menu, MenuItem } from '@mui/material'
import dayjs from 'dayjs'
import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import Select from 'react-select'
import userIcon from 'src/assets/user_icon.png'
import { API_URL_ARRAY } from 'src/consumer/constants'
import { JournalContext } from 'src/consumer/context/JournalContext'
import { ProfileContext } from 'src/consumer/context/ProfileContext'
import {
  clearCustomApiBaseUrl,
  resolveApiDomainConfig,
  setStoredDefaultApiBaseUrl,
} from 'src/consumer/services/apiDomainConfig'
import { mediaURL } from 'src/consumer/services'
import { logoutHandler } from 'src/consumer/services/loginLogoutHandlers'
import { GenericDisplayFlex } from 'src/mentor/layout/Styles'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import { DisplayFlexColumn } from '../DailyPlay/DailyPlayStyles'
import { formatTime } from '../LeaderboardPage/LeaderboardPageComponents'
import { StartsInTextOne, StartsInTextTwo } from '../MyLiveSessions/MyLiveSessionStyles'
import { canEventBeJoined, getMyRoleForThisEvent } from '../MyLiveSessions/my-live-sessions-utils'
import {
  BookedSlotItemContainer,
  BookedSlotOverviewContainer,
  BookedSlotOverviewHeading,
  BookedSlotOverviewNewSlotButton,
  BrandLogo,
  ConsumerProfileButton,
  DropDownContainer,
  FlexContainer,
  GlobalNavCountryCode,
  JoinButton,
  JoinStripHeading,
  MoreDetailsText,
  PageSelectStyles,
  PageSelectStylesDark,
  SessionInfoStripContainer,
  SessionStartsInContainer,
} from './GlobalNavStyles'
import { getDataWithParams } from 'src/consumer/services/profileService'
import { isValidHttpUrl } from 'src/mentor/helpers/utilityFunctions'

export const BrandLogoWithLocation = ({ darkText }) => {
  const navigate = useNavigate()
  return (
    <div className="d-flex position-relative">
      <BrandLogo
        src={APP_CONSTANTS.APP_LOGO_LINK}
        onError={(e) => {
          e.target.src = logo_brand
        }}
        onClick={() => {
          navigate('/')
        }}
      />
      <GlobalNavCountryCode darkText={darkText}>
        {localStorage.getItem('countryCode')?.toUpperCase()}
      </GlobalNavCountryCode>
    </div>
  )
}

export const PageSelectDropdown = (props) => {
  let tileId = props?.tileId
  let styles = PageSelectStyles

  const [isHovered, setIsHovered] = useState(false)

  const handleMouseEnter = () => {
    setIsHovered(true)
  }

  const handleMouseLeave = () => {
    setIsHovered(false)
  }

  if (props?.darkText) {
    styles = PageSelectStylesDark
  }

  return (
    <DropDownContainer
    // onClick={handleMouseEnter}
    // onMouseEnter={handleMouseEnter}
    // onMouseLeave={handleMouseLeave}
    >
      <Select
        {...props}
        isSearchable={false}
        styles={styles}
        components={{ IndicatorSeparator: () => null }}
        // menuIsOpen={isHovered}
      />
    </DropDownContainer>
  )
}

export const GlobalNavProfileDropdown = (props) => {
  const { setBookedSlotsDrawerOpen, windowWidth } = props
  const lang = props?.unSecureSetupData?.appLanguages
  const langPart = lang?.slice(0, 6)
  const [anchor, setAnchor] = useState(null)
  const [languageAnchor, setLanguageAnchor] = useState(null)
  const [moreVisible, setMoreVisible] = useState(langPart?.length !== lang?.length)
  const { journalData, setJournalData } = useContext(JournalContext)
  const { profileData } = useContext(ProfileContext)
  const availableRoles = getAllRolesInBoolean()

  let toggleBackground
  if (profileData?.profilePicId) {
    if (isValidHttpUrl(profileData?.profilePicId)) {
      toggleBackground = profileData?.profilePicId
    } else {
      toggleBackground = `${mediaURL}${profileData?.profilePicId}`
    }
  } else {
    toggleBackground = userIcon
  }
  function handleMenuClose() {
    setAnchor(null)
  }
  function handleMenuOpen(event) {
    setAnchor(event.currentTarget)
  }
  function handleLanguageMenuOpen(event) {
    setLanguageAnchor(event.currentTarget)
  }
  function handleLanguageMenuClose() {
    setLanguageAnchor(null)
  }

  const navigate = useNavigate()

  const apiDomainConfig = resolveApiDomainConfig()
  const presentApiURL = apiDomainConfig.effectiveApiBaseUrl
  let apiUrlText = API_URL_ARRAY?.find((item) => item?.url === presentApiURL)?.faceValue
  apiUrlText = apiUrlText || presentApiURL

  return (
    <div>
      <ConsumerProfileButton aria-label="menu" onClick={handleMenuOpen}>
        <Avatar src={toggleBackground} sx={{ bgcolor: '#3B007B' }} variant="square" />
      </ConsumerProfileButton>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <ProfileMenuItem
          customSx={{
            backgroundColor: '#622fdd',
            '&:hover': {
              backgroundColor: '#622fdd',
            },
            color: '#FFF',
            padding: '3px 8px',
          }}
          onClick={handleLanguageMenuOpen}
        >
          <ArrowLeftIcon />
          {props?.localizedStrings?.languages || 'Languages'}
        </ProfileMenuItem>

        {presentApiURL !== API_URL_ARRAY?.find((item) => item?.faceValue === 'LIVE')?.url && (
          <ProfileMenuItem
            customSx={{ bgcolor: '#e3e7ff' }}
            onClick={() => {
              clearCustomApiBaseUrl()
              setStoredDefaultApiBaseUrl(
                API_URL_ARRAY?.find((item) => item?.faceValue === 'LIVE')?.url,
              )
              window.location.reload()
            }}
          >
            {apiUrlText} server : Go live ?
          </ProfileMenuItem>
        )}

        <ProfileMenuItem
          onClick={() => {
            handleMenuClose()
            navigate('/profile', {})
          }}
        >
          {props?.localizedStrings?.profile_settings || 'Profile Settings'}
        </ProfileMenuItem>

        <ProfileMenuItem
          onClick={() => {
            if (availableRoles.isBusinessCustomer || availableRoles.isBusinessProspect) {
              navigate('/workplace')
            } else {
              navigate('/aumhum-for-workplace')
            }
            handleMenuClose()
          }}
        >
          {availableRoles.isBusinessCustomer || availableRoles.isBusinessProspect
            ? 'AUMHUM Business'
            : 'AUMHUM for Business'}
        </ProfileMenuItem>

        {(availableRoles.isClinicManager ||
          availableRoles.isClinicProspect ||
          availableRoles.isClinicOwner) && (
          <ProfileMenuItem
            onClick={() => {
              navigate('/clinic-home')
              handleMenuClose()
            }}
          >
            Manage your AUMHUM Clinic
          </ProfileMenuItem>
        )}

        {(availableRoles.isClinicAssistant || availableRoles.isChamberScreen) && (
          <ProfileMenuItem
            onClick={() => {
              navigate('/ca-home/chamber-screen-home')
              handleMenuClose()
            }}
          >
            Use AUMHUM as Chamber Screen
          </ProfileMenuItem>
        )}

        {availableRoles.isClinicAssistant && (
          <ProfileMenuItem
            onClick={() => {
              navigate('/ca-home')
              handleMenuClose()
            }}
          >
            Use AUMHUM as Clinic Assistant
          </ProfileMenuItem>
        )}

        {windowWidth < 520 && (
          <ProfileMenuItem
            onClick={() => {
              handleMenuClose()
              setBookedSlotsDrawerOpen(true)
            }}
          >
            1-on-1 sessions
          </ProfileMenuItem>
        )}

        <ProfileMenuItem
          onClick={() => {
            handleMenuClose()
            navigate('/leaderboard', {})
          }}
        >
          Leaderboard
        </ProfileMenuItem>

        {windowWidth < 520 && (
          <ProfileMenuItem
            onClick={() => {
              handleMenuClose()
              setJournalData({
                showJournal: true,
                callSource: 'navbar',
                data: { callSourceId: 'navbar', sourceName: 'navbar' },
                pageState: '',
                subscription: '',
              })
            }}
          >
            Journals
          </ProfileMenuItem>
        )}

        <ProfileMenuItem
          onClick={() => {
            handleMenuClose()
            navigate('/gift-card', {})
          }}
        >
          {props?.localizedStrings?.gift_option || 'Gifting'}
        </ProfileMenuItem>

        <ProfileMenuItem
          onClick={() => {
            handleMenuClose()
            logoutHandler()
            if (window.location.pathname === '/') {
              window.location.reload()
            } else {
              navigate('/login', {})
              // window.location.reload()
            }
          }}
        >
          {props?.localizedStrings?.logout || 'Logout'}
        </ProfileMenuItem>
      </Menu>
      <Menu
        anchorEl={languageAnchor}
        open={Boolean(languageAnchor)}
        onClose={handleLanguageMenuClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {(moreVisible ? langPart : lang)?.map((item, index) => {
          return (
            <MenuItem
              key={index}
              onClick={() => {
                sessionStorage.setItem('languageCode', item?.id)
                window.location.reload()
              }}
            >
              {item?.localLanguageName}
            </MenuItem>
          )
        })}
        {moreVisible && (
          <MenuItem
            onClick={(e) => {
              e.stopPropagation()
              setMoreVisible(false)
            }}
          >
            {props?.localizedStrings?.more || 'More'}→
          </MenuItem>
        )}
      </Menu>
    </div>
  )
}

function ProfileMenuItem({
  customSx,
  includeAuthority,
  excludeAuthority,
  children,
  ...restMenuItemProps
}) {
  const MenuItemDefaultStyles = {
    display: 'flex',
    justifyContent: 'center',
  }
  var role = localStorage.getItem('authorities')

  function validateAuth() {
    if (!includeAuthority && !excludeAuthority) {
      return true
    }
    const includeRoleFound = JSON.parse(role).find((rol) => rol === includeAuthority)
    const excludeRoleFound = JSON.parse(role).find((rol) => rol === excludeAuthority)

    if (Boolean(includeRoleFound)) {
      return true
    }
    if (excludeAuthority) {
      if (Boolean(excludeRoleFound)) {
        return false
      } else {
        return true
      }
    }
    return false
  }

  return validateAuth() ? (
    <MenuItem sx={{ ...MenuItemDefaultStyles, ...customSx }} {...restMenuItemProps}>
      {children}
    </MenuItem>
  ) : (
    <></>
  )
}

export const SlotNotificationPage = ({ partialBookedSlotsData, withMaxHeight, profileData }) => {
  const navigate = useNavigate()

  return (
    <BookedSlotOverviewContainer withMaxHeight={withMaxHeight}>
      {partialBookedSlotsData?.length === 0 && (
        <BookedSlotOverviewHeading style={{ textAlign: 'center' }}>
          Oops! You do not have any upcoming events
          <BookedSlotOverviewHeading
            style={{ textAlign: 'center' }}
            secondary
            onClick={() => navigate('/my-live-sessions/booked-sessions')}
          >
            See all
          </BookedSlotOverviewHeading>
        </BookedSlotOverviewHeading>
      )}

      <BookedSlotOverviewNewSlotButton onClick={() => navigate('/my-live-sessions/new')}>
        Book a New Session
      </BookedSlotOverviewNewSlotButton>

      {partialBookedSlotsData?.length > 0 && (
        <>
          <DisplayFlexColumn>
            <BookedSlotOverviewHeading>Upcoming/Active Sessions</BookedSlotOverviewHeading>
            <BookedSlotOverviewHeading
              secondary
              onClick={() => navigate('/my-live-sessions/booked-sessions')}
            >
              See all
            </BookedSlotOverviewHeading>
          </DisplayFlexColumn>
          <DisplayFlexColumn style={{ gap: '10px' }}>
            {partialBookedSlotsData?.map((item, index) => {
              return (
                <BookedSlotItemContainer
                  key={index}
                  onClick={() => navigate(`/my-live-sessions/booked-sessions/${item?.id}`)}
                  pointer={!canEventBeJoined(item, dayjs().format('YYYY-MM-DD HH:mm:ss'))}
                >
                  <div>{item?.eventName}</div>
                  <StartsInTextOne selected>
                    {getMyRoleForThisEvent(item, profileData) === 'mentor' && `As Mentor`}
                    {getMyRoleForThisEvent(item, profileData) === 'panelist' && `As Panelist`}
                  </StartsInTextOne>
                  <StartsInTextOne selected>
                    {getMyRoleForThisEvent(item, profileData) === 'mentor' ||
                    getMyRoleForThisEvent(item, profileData) === 'panelist'
                      ? `Booked by ${item?.userName}`
                      : `with ${item?.mentorName}`}
                  </StartsInTextOne>
                  <GenericDisplayFlex sb style={{ marginTop: '10px' }}>
                    <div>
                      <StartsInTextOne selected>Starts</StartsInTextOne>
                      <StartsInTextTwo selected>
                        {dayjs?.utc(item?.startTime).local()?.format('MMM DD, h:mma')}
                      </StartsInTextTwo>
                    </div>
                    {canEventBeJoined(item, dayjs().format('YYYY-MM-DD HH:mm:ss')) && (
                      <button
                        onClick={(e) => {
                          navigate(`/l/${item?.slug}`)
                          e.preventDefault()
                          e.stopPropagation()
                        }}
                      >
                        <u>Join</u>
                      </button>
                    )}
                    {/* <DetailsButton>
                      <img src={about_icon} />
                      More Details
                    </DetailsButton> */}
                  </GenericDisplayFlex>
                </BookedSlotItemContainer>
              )
            })}
          </DisplayFlexColumn>
        </>
      )}
    </BookedSlotOverviewContainer>
  )
}

// export function NotificationsList() {
//   const {
//     notificationList: notificationsData,
//     refreshNotifications,
//     updateNotifications,
//     moreNotificationsAvailable,
//     markNotificationAsRead,
//   } = useContext(NotificationContext)
//   const [notificationsListAnchor, setNotificationListAnchor] = useState(false)
//   // const moreNotificationsAvailable = true

//   function toggleNotificationsShow(event) {
//     setNotificationListAnchor((prev) => {
//       if (Boolean(prev)) {
//         return null
//       }
//       return event.currentTarget
//     })
//   }
//   function handleOpenNotifications(event) {
//     setNotificationListAnchor(event.currentTarget)
//   }
//   function handleCloseNotifications(event) {
//     setNotificationListAnchor(null)
//   }

//   const [sentryRef] = useInfiniteScroll({
//     hasNextPage: moreNotificationsAvailable,
//     onLoadMore: () => {
//       console.log('loading more')
//       updateNotifications()
//     },
//     rootMargin: '0px 0px 20px 0px',
//   })

//   return (
//     <>
//       <NotificationIconButton onClick={handleOpenNotifications}>
//         <NotificationsIcon />
//       </NotificationIconButton>
//       <NotificationMenuComponent
//         anchorEl={notificationsListAnchor}
//         open={Boolean(notificationsListAnchor)}
//         onClose={handleCloseNotifications}
//         MenuListProps={{
//           'aria-labelledby': 'notification',
//           role: 'listbox',
//         }}
//         anchorOrigin={{
//           vertical: 'bottom',
//           horizontal: 'left',
//         }}
//         transformOrigin={{
//           vertical: 'top',
//           horizontal: 'center',
//         }}
//         TransitionComponent={Fade}
//         TransitionProps={{ timeout: 100 }}
//       >
//         <NotificationMenuHeading>Notifications</NotificationMenuHeading>
//         <hr
//           style={{
//             margin: '0px 15px',
//             // color: '#5500f382'
//             // opacity: 1,
//           }}
//         ></hr>
//         {notificationsData?.length <= 0 && (
//           <MenuItem disabled>
//             <NotificationListItemContainer>
//               <NotificationListItemText primary="You have no notifications." />
//             </NotificationListItemContainer>
//           </MenuItem>
//         )}
//         {notificationsData?.map((option, index) => (
//           <NotificationListItemComponent
//             key={option?.id}
//             index={index}
//             notificationData={option}
//             refreshNotifications={refreshNotifications}
//             handleMarkRead={markNotificationAsRead}
//           />
//         ))}
//         {moreNotificationsAvailable && <NotificationListItemSkeleton menuItemRef={sentryRef} />}
//       </NotificationMenuComponent>
//     </>
//   )
// }

// function NotificationListItemSkeleton({ menuItemRef }) {
//   return (
//     <MenuItem disabled ref={menuItemRef}>
//       <div
//         style={{
//           display: 'flex',
//           justifyContent: 'center',
//           alignItems: 'flex-start',
//           flexDirection: 'column',
//           width: '100%',
//           // padding: '0px 10px',
//         }}
//       >
//         <Skeleton
//           sx={{ maxWidth: '190px', width: '100%', backgroundColor: '#00000070' }}
//         ></Skeleton>
//         <Skeleton sx={{ width: '100%', backgroundColor: '#00000070' }}></Skeleton>
//       </div>
//     </MenuItem>
//   )
// }

// function NotificationListItemComponent({ notificationData, index, handleMarkRead }) {
//   const [notificationContextMenuAnchor, setNotificationContextMenuAnchor] = useState(null)
//   const [showContextMenu, setShowContextMenu] = useState(false)

//   function handleNotificationClick(event, index) { }

//   function handleNotificationContextMenuClick(event) {
//     setNotificationContextMenuAnchor(event.currentTarget)
//     setShowContextMenu(true)
//   }
//   function handleNotificationContextMenuClose() {
//     setShowContextMenu(false)
//   }

//   function onExitedContextMenu() {
//     setNotificationContextMenuAnchor(null)
//     setShowContextMenu(false)
//   }

//   async function markNotificationAsRead() {
//     // console.log({ notificationDataId: notificationData?.id, notificationData })
//     handleNotificationContextMenuClose()
//     handleMarkRead(notificationData?.notificationId)
//     // const resp = await putDataWithParams(
//     //   '/api/secure/user/notification/update-read',
//     //   {},
//     //   {
//     //     notificationId: notificationData?.notificationId,
//     //   },
//     // )

//     // if (resp.status === 200 && isCommonResponseSuccessful(resp?.data?.code)) {
//     //   refreshNotifications()
//     // } else {
//     //   toast.error('Could not mark notification as read. Please try again.')
//     // }
//   }

//   return (
//     <NotificationMenuItemContainer>
//       <MenuItem
//         onClick={(event) => handleNotificationClick(event, index)}
//         // sx={{ position: 'relative' }}
//         disableTouchRipple
//       >
//         <NotificationListItemContainer read={notificationData?.read}>
//           {notificationData?.title && (
//             <NotificationListItemPrimary>{notificationData?.title}</NotificationListItemPrimary>
//           )}
//           {notificationData?.description && (
//             <NotificationListItemSecondary>
//               {notificationData?.description && notificationData?.description?.length > 100
//                 ? notificationData?.description.slice(0, 100) + '...'
//                 : notificationData?.description}
//             </NotificationListItemSecondary>
//           )}
//           {notificationData?.createdTime && (
//             <NotificationListItemTime read={notificationData?.read}>
//               {dayjs(notificationData?.createdTime).fromNow()}
//             </NotificationListItemTime>
//           )}
//         </NotificationListItemContainer>
//       </MenuItem>
//       {!notificationData?.read && (
//         <NotificationContextMenuActionButton
//           size="small"
//           showButton={Boolean(notificationContextMenuAnchor)}
//           onClick={handleNotificationContextMenuClick}
//         >
//           <MoreHoriz />
//         </NotificationContextMenuActionButton>
//       )}
//       <Menu
//         anchorEl={notificationContextMenuAnchor}
//         open={showContextMenu}
//         onClose={handleNotificationContextMenuClose}
//         TransitionProps={{ onExited: onExitedContextMenu, timeout: 100 }}
//         transformOrigin={{ horizontal: 'right', vertical: 'top' }}
//         anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
//         TransitionComponent={Fade}
//         sx={{ padding: '0px 10px !important', marginTop: '2px' }}
//       >
//         <MenuItem onClick={markNotificationAsRead} disableTouchRipple>
//           <NotificationListItemContainer style={{ padding: '0px' }}>
//             <div
//               style={{
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 gap: '10px',
//                 alignItems: 'center',
//                 fontWeight: 600,
//               }}
//             >
//               <Check sx={{ fontSize: '15px' }} />
//               <NotificationListItemSecondary>Mark as read</NotificationListItemSecondary>
//             </div>
//           </NotificationListItemContainer>
//         </MenuItem>
//       </Menu>
//     </NotificationMenuItemContainer>
//   )
// }

export function NextSessionStrip({
  nextAvailableSlot,
  currentTime,
  eventsNotYetEndedList,
  areAllStripsVisible,
  showShowAllStrip,
  toggleShowAllStrips,
}) {
  const navigate = useNavigate()
  const [waitingData, setWaitingData] = useState()

  async function getAndSetWaitingData() {
    if (nextAvailableSlot?.meetingSrc === 'offline') {
      const response = await getDataWithParams(
        '/api/secure/patient-user/booked-event/get-my-waiting-status',
        { eventId: nextAvailableSlot?.id },
      )
      if (response?.status === 200) {
        setWaitingData(response?.data?.data)
      }
    }
  }

  useEffect(() => {
    getAndSetWaitingData()
  }, [])

  useEffect(() => {
    getAndSetWaitingData()
    const intervalId = setInterval(() => {
      getAndSetWaitingData()
    }, 2 * 60 * 1000)
    return () => clearInterval(intervalId)
  }, [])

  if (window.location.pathname === '/tile/patient-home') {
    return <></>
  }

  return (
    <>
      {nextAvailableSlot && canEventBeJoined(nextAvailableSlot, currentTime) && (
        <SessionInfoStripContainer>
          <FlexContainer>
            <JoinStripHeading>
              Live Session: {nextAvailableSlot?.eventName}
              {nextAvailableSlot?.appointmentNumber && `(${nextAvailableSlot?.appointmentNumber})`}
            </JoinStripHeading>
            {dayjs?.utc(nextAvailableSlot?.startTime)?.local()?.isBefore(dayjs?.(currentTime)) ? (
              <SessionStartsInContainer>Started</SessionStartsInContainer>
            ) : (
              <SessionStartsInContainer>
                Starts in{' '}
                {moment
                  ?.utc(nextAvailableSlot?.startTime)
                  ?.diff(dayjs?.(currentTime), 'seconds' > 60)
                  ? formatTime(
                      moment
                        ?.utc(nextAvailableSlot?.startTime)
                        ?.diff(dayjs?.(currentTime), 'seconds'),
                      true,
                    )
                  : 'less than a minute'}
              </SessionStartsInContainer>
            )}
            {waitingData?.waitListNumber && (
              <JoinStripHeading style={{ marginTop: '5px' }}>
                Waitlist Number: #{waitingData?.waitListNumber}
              </JoinStripHeading>
            )}
          </FlexContainer>
          <FlexContainer>
            {showShowAllStrip && (
              <MoreDetailsText onClick={toggleShowAllStrips}>
                {eventsNotYetEndedList?.filter((item) => canEventBeJoined(item, currentTime))
                  ?.length -
                  1 >
                  0 &&
                  (areAllStripsVisible
                    ? 'Hide other sesions'
                    : `+ ${
                        eventsNotYetEndedList?.filter((item) => canEventBeJoined(item, currentTime))
                          ?.length - 1
                      } joinable sessions`)}
              </MoreDetailsText>
            )}
            {dayjs?.utc(nextAvailableSlot?.startTime)?.local()?.isBefore(dayjs?.(currentTime)) ? (
              <JoinButton onClick={() => navigate(`/l/${nextAvailableSlot?.slug}`)}>
                Join Now
              </JoinButton>
            ) : (
              <JoinButton onClick={() => navigate(`/l/${nextAvailableSlot?.slug}`)}>
                Join & Wait
              </JoinButton>
            )}
          </FlexContainer>
        </SessionInfoStripContainer>
      )}
    </>
  )
}
